import { CellTypeNames } from './CellTypeConstants';

type TranslationFunction = (translationKey: string) => string;

export const getCellTypeTranslationKey = (cellTypeName: CellTypeNames): string => {
    const keyMap: Record<CellTypeNames, string> = {
        [CellTypeNames.AUTO]: 'auto',
        [CellTypeNames.NUMBER]: 'number',
        [CellTypeNames.CURRENCY]: 'currency',
        [CellTypeNames.PERCENTAGE]: 'percentage',
        [CellTypeNames.TEXT]: 'text',
        [CellTypeNames.DATE_TIME]: 'dateTime',
        [CellTypeNames.CHECKBOX]: 'checkbox',
    };
    return keyMap[cellTypeName] || 'auto';
};

export const translateCellType = (cellTypeName: CellTypeNames, translate: TranslationFunction): string => {
    const key = getCellTypeTranslationKey(cellTypeName);
    return translate(`cellType.${key}`);
};
